import axios from 'axios';
import { store } from '../store';
import { getLoginObjDetails } from '../login/login.selector';

/**
 * Centralized API call function for all Redux service calls
 * @param url - The API endpoint URL
 * @param data - The payload data to send
 * @param method - HTTP method (default: 'POST')
 * @returns Promise with axios response
 */
export const makeApiCall = async (
	url: string,
	data: any,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'POST',
) => {
	const state = store.getState();
	console.log('JWT Token:', getLoginObjDetails(state));
	const token = getLoginObjDetails(state)?.jwtToken || null;

	const config = {
		method,
		url,
		data,
		headers: {
			'Content-type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	};

	return axios(config);
};

/**
 * Centralized API call function for form-encoded data (URLSearchParams)
 * @param url - The API endpoint URL
 * @param params - URLSearchParams object with form data
 * @param method - HTTP method (default: 'POST')
 * @returns Promise with axios response
 */
export const makeFormApiCall = async (
	url: string,
	params: URLSearchParams,
	method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'POST',
) => {
	const state = store.getState();
	const token = getLoginObjDetails(state)?.jwtToken || null;

	const config = {
		method,
		url,
		data: params,
		headers: {
			'Content-type': 'application/x-www-form-urlencoded',
			Authorization: `Bearer ${token}`,
		},
	};

	return axios(config);
};

/**
 * Legacy function for backward compatibility
 * @deprecated Use makeApiCall instead
 */
export const makePostCall = (url: string, data: any) => {
	return makeApiCall(url, data, 'POST');
};
